<div class="login-failed-message">
    <i class="bi bi-emoji-frown"></i>
    <div>{{ 'label.login_failed' | translate }}</div>
    <div class="secondary">{{ 'label.please_try_again' | translate }}</div>
</div>
